module.exports = __webpack_public_path__ + "static/outliers-a17ec93011b437a86e0268214290d765.jpg";